import React from "react";
import { isArray } from "lodash-es";
import PropTypes from "kf-proptypes/widgets";

import { MultiDimensionProperty } from "./index.jsx";
import {
  KfIcon,
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS
} from "../../common/components/primitives/kf_icon/index.jsx";

export function PaddingProperty({
  label,
  value = "0px",
  onChange = () => {},
  onReset,
  modified,
  inheritedFrom,
  units,
  showReset,
  showInherit,
  getPanelContainer
}) {
  return (
    <MultiDimensionProperty
      label={label}
      value={
        value.left ? [value.left, value.top, value.right, value.bottom] : value
      }
      inheritedFrom={inheritedFrom}
      showReset={showReset}
      showInherit={showInherit}
      getPanelContainer={getPanelContainer}
      onChange={(value) => {
        if (isArray(value)) {
          onChange({
            left: value[0],
            top: value[1],
            right: value[2],
            bottom: value[3]
          });
        } else {
          onChange({
            left: value,
            top: value,
            right: value,
            bottom: value
          });
        }
      }}
      onReset={onReset}
      modified={modified}
      units={units}
      dimensions={[
        {
          title: "Left Padding",
          icon: (
            <KfIcon
              icon={KF_ICONS.INNER_ALIGN_LEFT}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
            />
          )
        },
        {
          title: "Top Padding",
          icon: (
            <KfIcon
              icon={KF_ICONS.INNER_ALIGN_UP}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
            />
          )
        },
        {
          title: "Right Padding",
          icon: (
            <KfIcon
              icon={KF_ICONS.INNER_ALIGN_RIGHT}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
            />
          )
        },
        {
          title: "Bottom Padding",
          icon: (
            <KfIcon
              icon={KF_ICONS.INNER_ALIGN_BOTTOM}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
            />
          )
        }
      ]}
    />
  );
}

PaddingProperty.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  modified: PropTypes.bool,
  units: PropTypes.bool,
  inheritedFrom: PropTypes.string,
  showInherit: PropTypes.bool,
  showReset: PropTypes.bool,
  getPanelContainer: PropTypes.func
};
